import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App.tsx';
import Falha from './components/layout/Falha.tsx';
import { registrarServiceWorker } from './lib/pwa.ts';
import './styles/index.css';

registrarServiceWorker();

const raiz = document.getElementById('root');
if (!raiz) throw new Error('elemento #root não encontrado');

createRoot(raiz).render(
  <StrictMode>
    <Falha>
      <App />
    </Falha>
  </StrictMode>,
);
